import MojitoCore from 'mojito/core';
import { isEmpty } from 'mojito/utils';
import MenuRow from 'presentation/components/menu-row/index.js';
import { ALL_SPORTS_ITEM_ID, useSportFilterItems, useSportFilterMenuConfig } from './hooks';

const classUtils = MojitoCore.Base.classUtils;

export default function SportsFilter(props) {
    const { mojitoTools, sportIds, selectedSportId, onSportChange, class: className } = props;
    const { config } = mojitoTools;

    const menuItems = useSportFilterItems(sportIds, mojitoTools);
    const menuConfig = useSportFilterMenuConfig(config.sportsMenuRow, selectedSportId, config);

    if (isEmpty(menuItems)) {
        return null;
    }

    const onItemClicked = itemId =>
        onSportChange(itemId === ALL_SPORTS_ITEM_ID ? undefined : itemId);

    return (
        <MenuRow
            class={classUtils.classNames('ta-SportsFilter', className)}
            config={menuConfig}
            menuItems={menuItems}
            selectedItemId={selectedSportId || ALL_SPORTS_ITEM_ID}
            cbItemClicked={onItemClicked}
        />
    );
}
